<template>
  <v-container>
    <div class="container-inner">
      <div v-if="!!getActiveWarehouse">
        <PageTitle title="Dashboard" />
        <div class="home-content">
          <div class="dashboard__wrapper">
            <DashboardSummary />
          </div>
          <div class="dashboard__wrapper">
            <LocationOverview :warehouse="warehouse" />
          </div>
        </div>
      </div>
      <SelectWarehouse v-else />
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

import PageTitle from '@/components/page/PageTitle'
import DashboardSummary from '@/components/dashboard/DashboardSummary'
import LocationOverview from '@/components/locations/LocationOverview'
import SelectWarehouse from '@/views/SelectWarehouse'

export default {
  name: 'Dashboard',
  components: {
    PageTitle,
    DashboardSummary,
    LocationOverview,
    SelectWarehouse
  },
  computed: {
    ...mapGetters('warehouses', ['getActiveWarehouse']),
    warehouse () {
      return this.getActiveWarehouse
    }
  }
}
</script>

<style scoped lang="scss">
.dashboard__wrapper {
  margin-bottom: 30px;
}
</style>
